export class JournalListFilters {
  startDate: string = "";
  endDate: string = "";
  types: number[] = [];
  categories: number[] = [];
  usages: number[] = [];
  branches: number[] = [];
}

export class PropertyJournalListFilters {
  startDate: string = "";
  endDate: string = "";
  types: number[] = [];
}
